import React from 'react'
import Chip from './Chip'

class AreaDirectorArticleJobsIndex extends React.Component {
  render() {
    var tags;

    const rows = this.props.data.map((job) => {
      if (job.tags.length > 0) {
        tags = job.tags.map((tag) => {
          return (
            <div key={tag.key}>
              <Chip theme={tag.style}>{tag.text}</Chip>
            </div>
            );
        });
      } else {
        tags = "-";
      }
      return (
        <a key={job.index} className="list-group-item u-hover--raised" href={job.href}>
          <div className="d-flex w-100 align-items-center cursor-pointer row ml-2">
            <div className="d-flex flex-column col-6 col-lg-3">
              <small className="grey-text text-darken-2">{job.page_header}</small>
              <small className="grey-text text-darken-2">{job.headline}</small>
            </div>

            <div className="col-lg-5 d-none d-lg-block article-chips-container">
              {tags}
            </div>

            <div className="d-flex flex-column col-5 col-lg-3">
              <small className="grey-text text-darken-2">{job.publications}</small>
            </div>

            <div className="d-flex grey-text text-darken-2 flex-column col-1 align-items-center ml-auto">
              <i className="material-icons">keyboard_arrow_right</i>
            </div>
          </div>
        </a>
      )
    })

    return (
      <ul className="list-group list-group-flush mb-6">
        {rows}
      </ul>
    )
  }
}

export default AreaDirectorArticleJobsIndex
